import { login, logout, getSellerInfo, resetSellerPwd, forgetSellpwd, sendCode } from '@/api/user'
import { getToken, setToken, removeToken } from '@/utils/storage'

const user = {
  state: {
    token: getToken()
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    }
  },

  actions: {
    // 登录
    Login ({ commit }, userInfo) {
      return new Promise((resolve, reject) => {
        login(userInfo.username, userInfo.password).then(response => {
          setToken(response.token)
          commit('SET_TOKEN', response.token)
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 登出
    LogOut ({ commit, state }) {
      return new Promise((resolve, reject) => {
        logout(state.token).then(() => {
          commit('SET_TOKEN', '')
          removeToken()
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 前端 登出
    FedLogOut ({ commit }) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '')
        removeToken()
        resolve()
      })
    },

    // 获取商家信息
    getSellerInfo ({ commit, state }) {
      return new Promise((resolve, reject) => {
        getSellerInfo().then((response) => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 修改商家登录密码
    resetSellerPwd ({ commit, state }, payload) {
      return new Promise((resolve, reject) => {
        resetSellerPwd(payload).then((response) => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 忘记密码修改
    forgetSellpwd ({ commit, state }, payload) {
      return new Promise((resolve, reject) => {
        forgetSellpwd(payload).then((response) => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 发送验证码
    sendCode ({ commit, state }, payload) {
      return new Promise((resolve, reject) => {
        sendCode(payload).then((response) => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    }
  }
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js